export const NONE = 'None';
export const SideA = 'Side A';
export const SideA_DIC = 'Side A DIC';
export const SideA_IDL = 'Side A IDL';

export const SideATypes = [
  NONE,
  SideA,
  SideA_DIC,
  SideA_IDL
];

export const SideAOptions =  {
  NONE: { value: '', label: NONE },
  SideA: { value: SideA, label: SideA },
  SideA_DIC: { value: SideA_DIC, label: SideA_DIC },
  SideA_IDL: { value: SideA_IDL, label: SideA_IDL },
} as const;
